




import * as CommonFunctions from "./commons/CommonService.Functions";
import { ContractConceptRelationship, CreateContractConceptRelationship } from "../models/Entities/Contracts/ContractConceptRelationship";
import { IResult } from "../models/HttpResult";
import { ContractConceptRelationshipMinimal } from "../models/Entities/Contracts/ContractConceptRelationshipMinimal";

const baseUrl = (process.env.REACT_APP_BILLER_API_GATEWAY || "").replace(/\/$/, "") + "/contracts";

// Obtener todas las relaciones para un contrato específico
export const getAllContractConceptFormRelationships = async (contractId: number, token: string, formConcept?: string): Promise<ContractConceptRelationship[]> => {
  const url = `${baseUrl}/${contractId}/concepts/Relationship` + (formConcept ? `?formConcept=${encodeURIComponent(formConcept)}` : "");
  return CommonFunctions.apiRequest<ContractConceptRelationship[]>(url, token, "getAllContractConceptFormRelationships", { method: "GET" });
};

// Obtener relaciones mínimas (vista mínima) para un contrato específico
export const getContractConceptFormRelationshipsMinimal = async (
  contractId: number,
  token: string,
  formConcept?: string
): Promise<ContractConceptRelationshipMinimal[]> => {
  // Swagger: GET /contracts/{contractId}/concepts/Relationship/minimal?formConcept=
  const base = `${baseUrl}/${contractId}/concepts/Relationship/minimal`;
  const url = formConcept ? `${base}?formConcept=${encodeURIComponent(formConcept)}` : base;
  return CommonFunctions.apiRequest<ContractConceptRelationshipMinimal[]>(url, token, "getContractConceptFormRelationshipsMinimal", { method: "GET" });
};

// Obtener una relación por ID

export const getContractConceptFormRelationshipById = async (conceptRelationshipId: number, token: string): Promise<ContractConceptRelationship> => {
  const url = `${baseUrl}/concepts/Relationship/${conceptRelationshipId}`;
  return CommonFunctions.apiRequest<ContractConceptRelationship>(url, token, "getContractConceptFormRelationshipById", { method: "GET" });
};

// Crear una nueva relación

export const createContractConceptFormRelationship = async (contractId: number, data: CreateContractConceptRelationship, token: string): Promise<ContractConceptRelationship[]> => {
  return CommonFunctions.apiRequest<ContractConceptRelationship[]>(`${baseUrl}/${contractId}/concepts/Relationship`, token, "createContractConceptFormRelationship", {
    method: "POST",
    body: JSON.stringify(data)
  });
};

// Actualizar una relación existente

export const updateContractConceptFormRelationship = async (id: number, data: ContractConceptRelationship, token: string): Promise<ContractConceptRelationship[]> => {
  const url = `${baseUrl}/concepts/Relationship`;
  return CommonFunctions.apiRequest<ContractConceptRelationship[]>(url, token, "updateContractConceptFormRelationship", {
    method: "PUT",
    body: JSON.stringify(data)
  });
};

// Eliminar una relación

export const deleteContractConceptFormRelationship = async (conceptRelationshipId: number, token: string): Promise<IResult<number>> => {
  const url = `${baseUrl}/concepts/Relationship/${conceptRelationshipId}`;
  return CommonFunctions.apiRequest<IResult<number>>(url, token, "deleteContractConceptFormRelationship", { method: "DELETE" });
};
